import React from 'react'
import { FlexView, Card } from '../../../components/common'
import styled from 'styled-components'
import length from '../../../assets/icons/sre-length.svg'
import pipe from '../../../assets/icons/sre-pipe.svg'
import buoy from '../../../assets/icons/marine-buoy.svg'
import { useTranslation } from 'react-i18next'
import { GiHole } from 'react-icons/gi'
const AppIcon = styled.img`
    width: ${props => props.width || '22px'}; 
    height: ${props => props.height || '30px'}; 
`

const InfoCard = styled(FlexView)`
    border: 2px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 8px;
    margin-bottom: 16px;

    & .infoCardTitle {
    align-self: flex-start;
    font-style: normal;
    font-weight: normal;
    font-size: 17px;
    line-height: 30px;

    text-align: justify;
    color: #303030;
    margin: 10px 10px;
        
    }
`

const InfoSection = styled(Card)`
    border-right: 1px solid #E0E0E0;
    padding: 0px;
    display: inline-flex;
    margin-left:5px;
    box-shadow: none;
    border-radius: 0;
    flex-wrap: wrap;
    margin: 0px;
    :last-child {
        border-right: none
    }
    
    & p {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        text-align: justify;
        color: #303030;
    }

    & p.description {
        margin: 0px 30px 0px 0px;
        padding-bottom: 15px;
        color: #777777;
        text-transform: uppercase;
    }

    & p.values {
        margin: 0;
        padding-bottom: 0px;
    }

    & img.labelIcon {
        margin: 0 5px 0 20px;
    }
`

const FlexWrap = styled(FlexView)`
    flex-wrap: wrap; 
    padding-bottom: 15px;
`
const JobSummaryInfoCard = ({ jobInfoData, title }) => {
    const { t } = useTranslation()
    return (
        <InfoCard flexDirection='column' justifyContent="space-between" fontSize="medium" width="100%">
            <h6 className="infoCardTitle">{title}</h6>
            <FlexWrap flexDirection="row" width="">
                {jobInfoData && jobInfoData.map((info, i) => (
                    <InfoSection key={i} flexDirection="row" minWidth="12em" maxWidth="12em">
                        <FlexView height="100%" width="100%" flexDirection='row' alignItems="center" justifyContent="space-around" fontSize="medium">
                            <p className="description">{t(info.description)}</p>
                            {
                                info.description === "In Downhole" ?
                                    <GiHole color='#59CBE4' size='30px' />
                                    :
                                    <AppIcon src={info.icon} ></AppIcon>
                            }
                        </FlexView>
                        {
                            info.hasLength
                                ?
                                <FlexView flexDirection="row" maxWidth="50px" alignItems="center">
                                    <FlexView height="100%" flexDirection='row' alignItems="center" justifyContent="flex-start">
                                        <AppIcon className="labelIcon" src={title === "Pipes" ? pipe : buoy}></AppIcon>
                                        <p className="values">{info.amount}</p>
                                    </FlexView>
                                    <FlexView height="100%" flexDirection='row' alignItems="center" justifyContent="flex-end">
                                        <AppIcon className="labelIcon" src={length}></AppIcon>
                                        <p className="values">{info.length}</p>
                                    </FlexView>
                                </FlexView>
                                : <FlexView height="100%" flexDirection="row">
                                    <FlexView height="100%" flexDirection='row' alignItems="center" justifyContent="flex-start">
                                        <AppIcon className="labelIcon" src={title === "Pipes" ? pipe : buoy}></AppIcon>
                                        <p className="values">{info.amount}</p>
                                    </FlexView>
                                </FlexView>
                        }
                    </InfoSection>
                ))}
            </FlexWrap>

        </InfoCard >
    )

}

export default JobSummaryInfoCard